import { VERDICT_COLOR } from '@/types/walletIntel';
import type { ScreenVerdict } from '@/types/walletIntel';

interface Props {
  verdict: ScreenVerdict;
  pulse?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE = {
  sm: 'px-2.5 py-1 text-[11px]',
  md: 'px-3 py-1.5 text-[12px]',
  lg: 'px-3.5 py-2 text-sm',
};

const LABEL: Record<ScreenVerdict, string> = {
  clear: 'CLEAR',
  flagged: 'FLAGGED',
  needs_review: 'NEEDS REVIEW',
  error: 'ERROR',
};

export function VerdictBadge({ verdict, pulse = false, size = 'md' }: Props) {
  const c = VERDICT_COLOR[verdict];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold tracking-widest font-mono ${SIZE[size]}`}
      style={{ background: `${c}18`, color: c, border: `1px solid ${c}30` }}
    >
      {pulse && verdict === 'flagged' && (
        <span className="relative flex h-1.5 w-1.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500" />
        </span>
      )}
      {LABEL[verdict]}
    </span>
  );
}
